import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Avatar from "@mui/material/Avatar";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Button from "@mui/material/Button";
import AudioPlayer from "material-ui-audio-player";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

import FileImg from "../../../../assets/media/file-img.png";

const ChattingText = ({
  sendBy,
  voice,
  messageText,
  messageType,
  profileImage,
  createdDate,
  attachmentLinks,
  messageId,
  roomId,
  isDeleted,
}) => {
  let viewportWidth = window.innerWidth || document.documentElement.clientWidth;

  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalImg, setModalImg] = useState("");

  const showFun = () => setShow(!show);
  const hideFun = () => setShow(false);

  const imgModalOpen = (url) => {
    setOpen(true);
    setModalImg(url);
  };
  const imgModalClose = () => setOpen(false);

  const chatSocket = useSelector((state) => state.chat.socket);

  const removeMessage = () => {
    // Read message
    chatSocket?.send(
      JSON.stringify({
        command: "delete_message",
        room_id: roomId,
        message_id: messageId,
      })
    );
  };

  return (
    <>
      <div className="single-text-field" type={sendBy} onMouseLeave={hideFun}>
        {sendBy === "other" && (
          <Avatar alt="Remy Sharp" src={profileImage && profileImage} />
        )}

        <div className="text-info">
          {isDeleted && (
            <div className="the-message deleted-message" type={messageType}>
              <p>This message is deleted</p>
            </div>
          )}

          {!isDeleted && (
            <div className="the-message" type={messageType}>
              {(messageType === "text" ||
                messageType === "text_and_attachments") &&
                messageText?.length > 0 && <p> {messageText} </p>}

              {messageType === "voice" && (
                <div className="audio__player">
                  <AudioPlayer
                    volume={viewportWidth < 1024 ? false : true}
                    src={voice}
                    order="standart"
                  />
                </div>
              )}

              {(messageType === "attachments" ||
                messageType === "text_and_attachments") &&
                attachmentLinks?.length > 0 && (
                  <div className="attachments">
                    {attachmentLinks?.map((attachment, i) => {
                      return (
                        <div
                          className="attachments__image"
                          onClick={() => imgModalOpen(attachment)}
                          key={i}>
                          {attachment.includes(".pdf") ? (
                            <img src={FileImg} alt="pdf" />
                          ) : (
                            <img src={attachment} alt="attachments" />
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}

              <MoreVertIcon onClick={showFun} className="option-icon" />
              {show && (
                <ul className="text-option-list">
                  {sendBy === "me" && (
                    <Button onClick={removeMessage}> Remove </Button>
                  )}
                  {messageType === "voice" && <Button> Download </Button>}
                </ul>
              )}
            </div>
          )}

          <span className="the-message-sent">
            {" "}
            {createdDate.time} - {createdDate.date}{" "}
          </span>
        </div>
        <Modal
          open={open}
          onClose={imgModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="img-modal">
          <div
            className="img-modal-url"
            file-type={modalImg.includes(".pdf") ? "pdf" : "img"}>
            <button onClick={imgModalClose}>
              {" "}
              <CloseIcon />{" "}
            </button>
            <img className="modal-img-pdf" src={modalImg} />

            {modalImg.includes(".pdf") && (
              <a href={modalImg}>
                <img className="modal-pdf-only" src={FileImg} />
                <span> Download </span>
              </a>
            )}
          </div>
        </Modal>
      </div>
    </>
  );
};

export default ChattingText;
